function fixImageDomain(imageUrl) {
    //http://radio101net.virtualcms.it
    imageUrl = imageUrl.replace('http://radio101net.virtualcms.it', 'https://www.r101.it');
    return imageUrl;
}

function addZeroMinutes(hours) {
    if (!hours.includes(':'))
        return hours + ':00';
    return hours;
}

function padMinute(minute) {
    if (parseInt(minute) < 10)
        return '0' + minute;
    return minute;
}

export default function (data, cmp) {
    if (data.palinsesto) {
        let indexDays = {
            lunedi: 'mon',
            martedi: 'tue',
            mercoledi: 'wed',
            giovedi: 'thu',
            venerdi: 'fri',
            sabato: 'sat',
            domenica: 'sun'
        };

        let myProps = {
            mon: [],
            tue: [],
            wed: [],
            thu: [],
            fri: [],
            sat: [],
            sun: [],
        };

        data.palinsesto.forEach(day => {
            day.programmi.forEach(program => {
                //console.log(program)
                myProps[indexDays[day.giorno]].push({
                    title: program.nome_programma,
                    thumbnail: fixImageDomain(program.image.low),
                    description: '',
                    hour_start: addZeroMinutes(program.hh_inizio),
                    hour_end: program.hh_fine + ':' + padMinute(program.mm_fine)
                });
            });
        });

        cmp.props = myProps;
        //console.log(data)
    }
}